import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { HandCoins } from "@phosphor-icons/react";
import { fmtBRL } from "@/lib/format";

export default function HandDialog({ rakePercent, rakeCap, onSubmit }) {
    const [open, setOpen] = useState(false);
    const [pot, setPot] = useState("");

    const confirm = async () => {
        if (!pot) { toast.error("Enter the pot"); return; }
        await onSubmit({ pot: parseFloat(pot) });
        setOpen(false);
        setPot("");
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button data-testid="btn-open-hand" variant="outline" className="h-10 border-gold/30">
                    <HandCoins size={16} className="mr-1.5" /> Record hand
                </Button>
            </DialogTrigger>
            <DialogContent className="bg-card">
                <DialogHeader><DialogTitle className="font-serif text-2xl">Record hand</DialogTitle></DialogHeader>
                <div>
                    <Label className="label-mini">Pot ($)</Label>
                    <Input data-testid="input-hand-pot" value={pot} onChange={(e) => setPot(e.target.value)} placeholder="80.00" />
                    <div className="mt-2 text-xs text-muted-foreground">
                        Rake calculated automatically: {rakePercent}% of the pot (max {fmtBRL(rakeCap)})
                    </div>
                </div>
                <DialogFooter>
                    <Button data-testid="btn-confirm-hand" onClick={confirm} className="btn-gold">Record hand</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
